import { Auth } from "../auth/auth";
import client from "../auth/client";
import {archivalClient } from "../auth/client";
import { getToast } from "../common/utils";
export const getContractsForAntdTable = async (reqBody: {
  apiProps: {
    doc_status: string;
  };
  queryParams: {
    page: number;
    page_size: number;
  };
}) => {
  const { apiProps, queryParams } = reqBody;
  const res = await client.post(
    `/doc_review/list_contracts/?page_size=${queryParams.page_size}&page=${queryParams.page}`,
    apiProps
  );
  return res.data;
};

export const getContractsForTable = async (
  query: { page_size?: number; page?: number },
  reqbody: { doc_status: string }
) => {
  const res = await client.post(
    `/doc_review/list_contracts/?page_size=${query.page_size}&page=${query.page}`,
    reqbody
  );
  return res.data;
};

export const getVerticals = async (
  query: { page_size?: number; page?: number } = { page_size: 10, page: 1 },
  reqbody: {} = {}
) => {
  try {
    const res = await client.get(
      `/common/vertical/list/?page_size=${query.page_size}&page=${query.page}`,
      { params: reqbody }
    );
    return res.data;
  } catch (err) {
    console.error("Error fetching verticals:", err);
    return err;
  }
};

export const getListOfVerticals = async ({
  verticalListQueryParams,
}: {
  verticalListQueryParams: string;
}) => {
  try {
    const res = await client.get(
      `/common/vertical/list/${verticalListQueryParams}`
    );
    return res.data;
  } catch (err) {
    console.error("Error fetching verticals:", err);
    return err;
  }
};

export const getVerticalCorpusMappings = async () => {
  try {
    const res = await client.get(
      `/common/vertical/corpus-mappings`
    );
    return res.data;
  } catch (err) {
    console.error("Error fetching vertical corpus mappings:", err);
    return err;
  }
};


 export const getVerticalFilesCount = async (params: { vertical_id?: string } = {}) => {
   const res = await client.get("/common/vertical/files/count/", { params });
   return res.data;
 };

export const addVertical = async (reqbody: {
  vertical_name: string;
  drive_link?: string;
}) => {
  const res = await client.post(`/common/vertical/add/`, reqbody);
  return res.data;
};

export const editVertical = async (reqbody: {
  vertical_id?: string;
  drive_link?: string;
  is_enabled?: boolean;
}) => {
  const res = await client.post(`/common/vertical/update/`, reqbody);
  return res.data;
};

export const getCommentsWithIdService = async (docId: string) => {
  const res = await client.post("/doc_review/get_google_doc_meta/", {
    doc_id: docId,
  });
  return res.data;
};

export const getUrlForSummaryFile = async (reqBody: {
  statuses: string[];
  vertical_id: string;
}) => {
  const res = await client.post(
    "/clause_check/clause_check_summary_export/",
    reqBody
  );

  return res.data;
};

export const getContractCountForStatus = async (vertical_id: string) => {
  const res = await client.get(
    `/clause_check/get_status_summary/?vertical_id=${vertical_id}`
  );
  return res.data;
};

export const getSignedUrlUsingDocId = async (docId: string) => {
  try {
    const res = await client.post("/clause_check/get_doc_signed_url/", {
      doc_id: docId,
    });

    return res.data;
  } catch (err) {}
};

export const getPdfUrlUsingDocIdForKCC = async (docId: string) => {
  try {
    const res = await client.post("/clause_check/v2/get_doc_signed_url/", {
      doc_id: docId,
    });

    return res.data;
  } catch (err) {}
};

export const getPdfUrlUsingFileIdForKCCAgentic = async (fileId: string) => {
  try {
    const res = await client.post("/clause_check/v3/get_doc_signed_url/", {
      file_id: fileId,
    });

    return res.data;
  } catch (err) {
    console.error("Error fetching signed URL for KCC Agentic:", err);
    throw err;
  }
};

export const getSignedUrlUsingDocIdForDueContracts = async (docId: string) => {
  const res = await client.post("/dashboard/due_contract/get_signed_url/", {
    due_contract_id: docId,
  });
  return res.data;
};

export const getVerticalList = async ({
  filter_is_enabled,
  enable_count_feature,
}: {
  filter_is_enabled: boolean | undefined;
  enable_count_feature: string | undefined;
}) => {
  const url = filter_is_enabled
    ? `/common/vertical/list/?filter_is_enabled=${filter_is_enabled}` +
      (enable_count_feature
        ? `&enable_count_feature=${enable_count_feature}`
        : "")
    : `/common/vertical/list/`;
  const res = await client.get(url);
  return res.data;
};

export const getClauseCheckListForSelectedVertical = async ({
  verticalId,
}: {
  verticalId: string;
}) => {
  try {
    const res = await client.get(
      `/common/list_clause_for_vertical/?vertical_id=${verticalId}`
    );
    return res.data;
  } catch (err: any) {
    getToast("Error", err?.message || "Could not fetch clause list data");
  }
};

export const enableDisableEntireVerticalURL = async (payload: any) => {
  const res = await client.post(`/common/vertical/update/`, payload);
  return res.data;
};

export const getDefaultDriveDirectory = async () => {
  const auth = Auth.getInstance();
  const res = await client.get(
    `/common/get_default_drive_dir_details/?token=${auth.getGoogleAccessToken()}`
  );
  return res.data;
};

// ── PA Configuration ────────────────────────────────────────────────────────
// The pa_config that controls RAG-Pipeline's doc hierarchy + folder semantics.
// One active row per deployment. Admin UI lives at ROUTES.paConfiguration.

export type PAConfigResponse = {
  pa_id: string;
  name: string;
  config_yaml: string;
  status: "draft" | "active";
  version: number;
  generated_by_ai: boolean;
  generation_metadata: Record<string, unknown>;
  updated_at: string | null;
};

export const getPAConfig = async (): Promise<PAConfigResponse | null> => {
  // Returns null when no active config exists (BE returns 404). Any other
  // error propagates.
  try {
    const res = await client.get("/common/pa-config/");
    return res.data;
  } catch (err: any) {
    if (err?.response?.status === 404) return null;
    throw err;
  }
};

export const savePAConfig = async (payload: {
  pa_id: string;
  name: string;
  config_yaml: string;
  status?: "draft" | "active";
  generated_by_ai?: boolean;
  generation_metadata?: Record<string, unknown>;
}) => {
  const res = await client.put("/common/pa-config/", payload);
  return res.data;
};

export type PAConfigDraftResponse = {
  config_yaml: string;
  sampled_files: { name: string; path: string }[];
  inferred_folder_levels: Record<string, [string, number][]>;
  heuristic_groups: Record<string, number>;
  model: string;
  generated_at: string;
  // Diagnostic fields from RAG-Pipeline — when the source drive is huge,
  // the walker caps at MAX_TOTAL_FILES / WALK_TIME_BUDGET_SECONDS and sets
  // sample_truncated=true so the admin knows to review carefully or point
  // at a smaller curated folder.
  sample_truncated?: boolean;
  walk_seconds?: number;
  total_files_sampled?: number;
};

export const generatePAConfigDraft = async (args: {
  source_vertical_id?: string;
  drive_folder_id?: string;
  pa_name_hint?: string;
}): Promise<PAConfigDraftResponse> => {
  // Proxies through Legacy BE (300s timeout) to RAG-Pipeline. Slow (15–60s
  // for a curated sample; up to a few minutes if the admin pointed at a
  // huge production drive). Keep the axios timeout slightly above the BE
  // side so we surface the BE's error message rather than a client-side
  // timeout when the pipeline stalls.
  const res = await client.post("/common/pa-config/generate/", args, {
    timeout: 320_000,
  });
  return res.data;
};

export const getVerticalBasedFilesCount = async (apiProps: {
  vertical_id?: string;
  status?: "active" | "expired" | "all";
}) => {
  // status is forwarded so the TTC header matches the CRD/KCC headers and the
  // chat agent's "count of files in this vertical" answer. BE defaults to
  // "active" when missing.
  const res = await client.post('/ttc/files/stats/', {
    vertical_id: apiProps.vertical_id,
    status: apiProps.status,
  });
  return res.data;
};

export const triggerManualSync = async (data: {
  vertical_id: string;
  is_manual_sync: boolean;
}) => {
  const res = await client.post("/auto_sync/trigger-sync", data);
  return res.data;
};

export const getVerticalArchivalJobs = async (data: any) => {
  const { vertical_id } = data?.apiProps || {};
  const { page = 1, page_size = 10 } = data?.queryParams || {};
  try {
    const res = await archivalClient.get(
      `/archival/jobs/${vertical_id}/verticals/`,
      {
        params: {
          page,
          page_size: page_size,
        },
      }
    );
    return res.data;

  } catch (error: any) {
    console.error("Error fetching vertical archival jobs:", error);
    return {
      status: false,
      status_message: error?.response?.data?.message || "Failed to fetch archival jobs",
      count: 0,
      results: [],
      previous: null,
      next: null,
    };
  }
};

export const getJobArchivalFiles = async (data: any) => {
  const { job_id } = data?.apiProps || {};
  const { page = 1, page_size = 10 } = data?.queryParams || {};
  
  try {
    const params: any = {
      page,
      page_size,
    };
    
    const res = await archivalClient.get(
      `/archival/jobs/${job_id}/files/`,
      { params }
    );
    return res.data;
  } catch (error: any) {
    console.error("Error fetching job archival files:", error);
    return {
      status: false,
      status_message: error?.response?.data?.message || "Failed to fetch archival files",
      count: 0,
      results: [],
      previous: null,
      next: null,
    };
  }
};

